import { render, staticRenderFns } from "./AnswerInputBox.vue?vue&type=template&id=152c396f&scoped=true"
import script from "./AnswerInputBox.vue?vue&type=script&lang=js"
export * from "./AnswerInputBox.vue?vue&type=script&lang=js"
import style0 from "./AnswerInputBox.vue?vue&type=style&index=0&id=152c396f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c396f",
  null
  
)

export default component.exports